import client from "../client"
import { MONTHLY_REVIEW, CURRENT_ENTRY } from "../queries"
import {
  updateReviewParentEntry,
  processReviewReflections,
  verifyCacheAndNetworkSync,
  compareSubscriptionToLocalStorage,
} from "../../functions/reviews"

/**
 * Determine if this is a valid path to act on subscriptions for monthly reviews.
 * @param {string} currentRoute the current route's path
 * @return {boolean} valid path
 */
const _isValidPath = currentRoute =>
  typeof currentRoute === "string" &&
  currentRoute.includes("compose/monthly") &&
  !currentRoute.includes("report")

/**
 * Handles updates for the `currentEntry` cache object data
 */
const CURRENT_ENTRY_SUBSCRIPTION = {
  /**
   * The data from cache after update
   * @param {import("apollo-boost").ApolloQueryResult<any>} data monthly review cache data
   */
  next({ data: { currentEntry: data }, loading, networkStatus, stale }) {
    if (loading) return
    console.log("LOG [Monthly Review / `currentEntry` Subscription]", { data })
    /** Update the review's entry in cache */
    /** Update the `currentEntry` in cache if found in review data lowlights */
    /** Update each entry in review data lowlights in cache, make array of entry keys with changes */
    /** Send review entry to server for update */
    /** Send each changed lowlight entry to server for update */

    // TODO: Create a batch server update queue feature
    /** Create batch queue server update item, add it to current queue */
    /** Trigger batch server queue update */
  },
  /**
   * The data from cache after update
   * @param {import("apollo-boost").ApolloQueryResult<any>} data monthly review cache data
   */
  err(data) {},
  complete() {},
}
/**
 * Handles updates for the `monthlyReview` cache object data and is triggered
 * whenever a user edits a monthly review, and changes the value of a field
 * within that review.
 */
export const MONTHLY_REVIEW_SUBSCRIPTION = {
  /**
   * The data from cache after update
   * @param {import("apollo-boost").ApolloQueryResult<any>} data monthly review cache data
   */
  next({ data: { monthlyReview: data }, loading, networkStatus, stale }) {
    /** Only reviews that have been saved should make it past this point, having an ID indicates so. */
    if (loading || !data.id) return
    // window.gql = gql
    // window.readfrag = cache.diff

    const { change: firstRun } = compareSubscriptionToLocalStorage(data)

    if (!firstRun) {
      // const hasChanges = cache.diff.query(MONTHLY_REVIEW, data)
      console.log("LOG [Monthly Review / `monthlyReview` Subscription]", {
        data,
        // hasChanges,
      })
      // debugger
      /** Update the review's entry in cache */
      try {
        updateReviewParentEntry(data, "cache-and-network")
      } catch (err) {
        alert(
          `Something unexpected happened while updating this review.  The issue has been logged and our team will be notified and follow up as necessary.  We will attempt to resolve the issue now by reloading the application.  If the issue persists, please contact support.`
        )
        window.location.assign("/a/account")
      }

      /** Update the the `currentEntry` in cache if found in review data lowlights */
      /** Update each entry in review data lowlights in cache, make array of entry keys with changes */
      // This happens individually after each edit, we don't need to do a mass update here
      //   processReviewReflections(data)
      /** Send review entry to server for update */
      /** Send each changed lowlight entry to server for update */

      /** Check cache and network sync, compare the `review` field of the review's parent document
       * in cache with the current `monthlyReview` cache object. */
      verifyCacheAndNetworkSync(data)

      // TODO: Create a batch server update queue feature
      /** Create batch queue server update item, add it to current queue */
      /** Trigger batch server queue update */
    } else {
      console.log("LOG: [monthlyReview subscription] recognized first run")
    }

    /** Save data to local storage for compare next time this runs */
    window.localStorage.setItem(`_monthlyReview`, JSON.stringify(data))
  },
  /**
   * The data from cache after update
   * @param {import("apollo-boost").ApolloQueryResult<any>} data monthly review cache data
   */
  err(data) {},
  complete() {},
}

/**
 *  Initialized subscriptions for monthly reviews
 * @param {string} currentRoute the current route's path
 * @return {[ZenObservable.Subscription]|any[]} an array of subscriptions
 */
export const initMonthlyReviewSubscriptions = currentRoute => {
  /** @type {ZenObservable.Subscription[]} */
  const subscriptions = []
  if (!_isValidPath(currentRoute)) return subscriptions
  subscriptions.push(
    client
      .watchQuery({ query: MONTHLY_REVIEW, fetchPolicy: "cache-only" })
      .subscribe(MONTHLY_REVIEW_SUBSCRIPTION)
  )
  subscriptions.push(
    client
      .watchQuery({ query: CURRENT_ENTRY, fetchPolicy: "cache-only" })
      .subscribe(CURRENT_ENTRY_SUBSCRIPTION)
  )
  return subscriptions
}
